import { render, staticRenderFns } from "./MaidRisk.vue?vue&type=template&id=0bff240c&"
import script from "./MaidRisk.vue?vue&type=script&lang=js&"
export * from "./MaidRisk.vue?vue&type=script&lang=js&"
import style0 from "./MaidRisk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidRisk.vue"
export default component.exports